import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiUrls } from '../const/Api-urls';
import { Observable } from 'rxjs';
import { APIServerResponse, VisitorCO } from '../models/ApiModels';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(
    private http: HttpClient,
  ) { }


  getPageDetailsBySchId(schId: any): Observable<APIServerResponse> {
    return this.http.get<APIServerResponse>(
      ApiUrls.schWebmaintance1 + '/page/Details',
      {
        params: { schoolId: schId }
      }
    );
  }

  createVisitorEnquiry(enquiry: VisitorCO): Observable<APIServerResponse> {
    return this.http.post<APIServerResponse>(
      ApiUrls.visitor + '/enquiry/add/web',
      enquiry
    );
  }

  getSchoolDetails(schId: number) {
    return this.http.get(ApiUrls.open + '/school/' + schId);
  }

  createNewVisitor(obj: any) {
    return this.http.post(ApiUrls.visitor + '/enquiry/add', obj);
  }

  getNewsByStatus(obj: any) {
    return this.http.get(ApiUrls.getNewsByStatus + '?status=' + obj?.status);
  }
  getWebNewsList(schId: any, days: any) {
    return this.http.get(ApiUrls.getWebNewsList + '?schoolId=' + schId + '&days=' + days);
  }

  getWebFaqListByStatus(status: any, schId: any) {
    return this.http.get(ApiUrls.getWebFaqByStatus + '?schoolId=' + schId + '&status=' + status);
  }


  getWebsiteConfigBySchoolId(schId: any): Observable<APIServerResponse> {
    return this.http.get<APIServerResponse>(ApiUrls.schWebmaintance1 + '/website/config/list?schoolId=' + schId);
  }
}
